'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentedProductDetailComponent = exports.rentedProductDetailComponent = {
    template: require('./rented-product-detail.html'),
    controllerAs: 'vm',
    bindings: {
        tgzId: '<',
        rentalHistory: '<'
    },
    controller: ["common", "gettextCatalog", "rentalProductsService", "Analytics", function rentedProductDetailController(common, gettextCatalog, rentalProductsService, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.$onChanges = bindingChanges;
        vm.saveRemark = saveRemark;
        vm.clearRemark = clearRemark;
        vm.isEditingRemark = false;
        vm.remark = '';
        vm.rentalProductsService = rentalProductsService;

        function init() {
            var pageTitle = vm.rentalHistory.productName ? gettextCatalog.getString('Rented product detail') + ' ' + vm.rentalHistory.productName + ' - ' + vm.rentalHistory.sellerArticleNumber : gettextCatalog.getString('Rented product detail');
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/rentals/rented-product-archive/' + vm.rentalHistory.id, pageTitle);
        }

        function bindingChanges(changes) {
            if (changes.rentalHistory && changes.rentalHistory.currentValue) {
                vm.rentalHistory = changes.rentalHistory.currentValue;
                vm.remark = vm.rentalHistory.remark;
            }
        }

        function saveRemark() {
            vm.rentalProductsService.setHistoryRemark(vm.rentalHistory.id, vm.rentalHistory.version, vm.remark).then(function (response) {
                vm.rentalHistory = response;
                vm.remark = vm.rentalHistory.remark;
                vm.isEditingRemark = false;
            });
        }

        function clearRemark() {
            vm.remark = '';
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/rented-product-detail.js
// module id = 891
// module chunks = 0